import React from 'react';
import {useQuery} from 'react-apollo-hooks';
import gql from 'graphql-tag';
import {Helmet} from 'react-helmet';

import {Loading} from 'ui-kit';
import {SettingsSection} from '../SettingsSection';

import {
  AddressForm,
  IdentityForm,
  LogoUpload,
  SubdomainForm,
} from './components';

export function Practice() {
  const {data, loading, error, refetch} = useQuery(gql`
    query AccountQuery {
      me {
        ... on StaffMember {
          id
          practice {
            id
            name
            phone
            address1
            address2
            city
            state
            zip
            contactEmail
            subdomain
            logoUrl
          }
        }
      }
    }
  `);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    console.error(data.error);
  }

  const {
    name,
    phone,
    contactEmail: email,
    address1,
    address2,
    city,
    state,
    zip,
    subdomain,
    logoUrl,
  } = data.me.practice;

  return (
    <div>
      <Helmet title="Account settings" />

      <SettingsSection
        title="Practice identity"
        description="These details will be shown to your patients frequently to help them identify your practice and get in touch."
      >
        <IdentityForm
          initialValues={{
            name,
            phone,
            email,
          }}
        />

        <LogoUpload logoUrl={logoUrl} onUpload={async () => await refetch()} />
      </SettingsSection>

      <SettingsSection
        title="Practice address"
        description="The primary address of your practice."
      >
        <AddressForm
          initialValues={{
            address1,
            address2,
            city,
            state,
            zip,
          }}
        />
      </SettingsSection>

      <SettingsSection
        title="Signup subdomain"
        description="Your patients can sign up for a membership by visiting this subdomain."
      >
        <SubdomainForm initialSubdomain={subdomain} />
      </SettingsSection>
    </div>
  );
}
